import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-base text-gray-700 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_ctx.events.length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { id: "events" }, "Events", -1)),
        _createVNode(_component_v_card, { class: "p-8 md:p-6 sm:p-4 mb-12 md:mb-8 shadow-md rounded-lg" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass({ 'mb-8': index < _ctx.events.length - 1 })
              }, [
                _createElementVNode("h3", {
                  class: _normalizeClass(["text-2xl md:text-xl sm:text-lg font-semibold mb-3 flex items-center gap-2 flex-wrap", { 'mt-0': index === 0 }])
                }, [
                  _createVNode(_component_v_icon, { size: "28" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-calendar-star", -1)
                    ]))]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(event.title), 1)
                ], 2),
                _createElementVNode("p", _hoisted_2, _toDisplayString(event.description), 1),
                _createVNode(_component_v_btn, {
                  color: "black",
                  class: "text-white text-none",
                  rounded: "lg",
                  href: event.link,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(event.linkLabel || 'Register here'), 1)
                  ]),
                  _: 2
                }, 1032, ["href"])
              ], 2))
            }), 128))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}